/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { colors } from '@constants/colors';
import { Icon } from '@mui';
import './details-table-blob-field.scss';

const DetailsTableBlobField = ({ value }) => {
  const [expanded, setExpanded] = useState(false);
  const [shouldExpand, setShouldExpand] = useState(false);

  const divRef = useRef(null);
  const innerRef = useRef(null);

  useEffect(() => {
    if (divRef.current && innerRef.current) {
      setShouldExpand(innerRef.current.clientHeight > divRef.current.clientHeight);
    }
  }, []);

  const toggleShowMore = useCallback(() => {
    setExpanded(prev => !prev);
  }, []);

  return (
    <div>
      <div>
        <div styleName={`value ${!expanded ? 'truncated' : ''}`} ref={divRef}>
          <p ref={innerRef}>{value}</p>
          {shouldExpand && !expanded && <div styleName="gradient">&nbsp;</div>}
        </div>
      </div>
      {shouldExpand &&
        <div styleName="show-more" onClick={toggleShowMore} role="presentation">
          <Icon role="img" color={colors.opacity.black0_6} style={{ paddingRight: '12px', width: '24px'}}>more_horiz</Icon>
          <div>{!expanded ? 'SHOW MORE' : 'SHOW LESS'}</div>
        </div>
      }
    </div>
  );
};

DetailsTableBlobField.propTypes = {
  value: PropTypes.string
};

export default DetailsTableBlobField;
